import Page from '../../classes/Page'
import { app } from '../../utils/store'

import each from 'lodash/each'
import gsap from 'gsap'
import { clamp } from '../../utils/math'

export default class LandingSalone extends Page{
    constructor(){
        super({
            id : 'landing_salone',
            element: '[data-app-page]',
            elements: { },
            // scroller: app.content
        })
    }

    create() {
        super.create()

        if(!app.device.mobile && this.elements.versions){ this.createVersions() }
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}